export default __webpack_public_path__ + "static/014-e3487fabc090277da526b8fd2b8d7e45.jpg";